var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aplayer',{key:_vm.Playkey,attrs:{"music":_vm.musicLists[_vm.bar],"controls":"controls","preload":"auto","autoplay":_vm.autoplay},on:{"hook:mounted":_vm.playMounted}})}
var staticRenderFns = []

export { render, staticRenderFns }